import { gql } from '@apollo/client';

export const UPDATE_ADOPTION = gql`
  mutation updateAdoption(
    $id: ID!
    $regNumber: String!
    $animalEnteredDate: String!
    $animalStatus: AnimalStatusInput!
    $animalSpecies: String!
    $animalSex: String
    $animalName: String
    $animalMicrochipStatus: String!
    $animalMicrochipNumber: String
    $animalLocation: String
    $animalLeaveDate: String
    $animalOtherObs: String
  ) {
    updateAdoption(
      id: $id
      input: {
        regNumber: $regNumber
        animalEnteredDate: $animalEnteredDate
        animalStatus: $animalStatus
        animalSpecies: $animalSpecies
        animalSex: $animalSex
        animalName: $animalName
        animalMicrochipStatus: $animalMicrochipStatus
        animalMicrochipNumber: $animalMicrochipNumber
        animalLocation: $animalLocation
        animalLeaveDate: $animalLeaveDate
        animalOtherObs: $animalOtherObs
      }
    ) {
      id
      regNumber
      animalEnteredDate
      animalStatus {
        entered
        adopted
        intermediated
      }
      animalSpecies
      animalSex
      animalName
      animalMicrochipStatus
      animalMicrochipNumber
      animalLocation
      animalLeaveDate
      animalOtherObs
      createdAt
      createdBy {
        id
        firstName
        lastName
        email
      }
      lastUpdate
      updatedBy {
        id
        firstName
        lastName
        email
      }
    }
  }
`;
